/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TRemoveFromArchiveDesktopModel,
  IRemoveFromArchiveDesktopRequest,
  IMappers,
  IRemoveFromArchiveDesktopResponse,
  IRemoveFromArchiveDesktopResponseError,
  TRemoveFromArchiveDesktopResponse,
} from './types';

const defaultConfig: TRemoveFromArchiveDesktopModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'chats',
  pathApi: '/v1/remove-from-archive-desktop/',
  hostType: 'api',
} as TRemoveFromArchiveDesktopModel;

function createRemoveFromArchiveDesktopModel(
  parameters: IRemoveFromArchiveDesktopRequest,
): TRemoveFromArchiveDesktopModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IRemoveFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IRemoveFromArchiveDesktopRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchRemoveFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IRemoveFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TRemoveFromArchiveDesktopResponse
> {
  const { response, statusCode } = await httpApi.fetch(createRemoveFromArchiveDesktopModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IRemoveFromArchiveDesktopResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IRemoveFromArchiveDesktopResponseError);
    }
  }

  return { response, statusCode } as TRemoveFromArchiveDesktopResponse;
}

export { defaultConfig, createRemoveFromArchiveDesktopModel, fetchRemoveFromArchiveDesktop };
